import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BrandHeader from "@/components/BrandHeader";
import { adminApi } from "@/lib/api";
import { usePageMeta } from "@/lib/usePageMeta";

const ITEMS = [
  { to: "/admin/dashboard", label: "Dashboard" },
  { to: "/admin/analytics", label: "Analytics" },
  { to: "/admin/leads", label: "Leads" },
  { to: "/admin/reviews", label: "Reviews" },
  { to: "/admin/duty", label: "Duty Schedule" },
  { to: "/admin/team", label: "Team" },
  { to: "/admin/offdays", label: "Off Days" },
  { to: "/admin/settings", label: "Settings" },
];

// Pass 59: a section stays highlighted on its subpages
// (/admin/analytics/marketing is still Analytics).
const isUnder = (path, to) => path === to || path.startsWith(`${to}/`);

export default function AdminLayout({ children }) {
  const loc = useLocation();
  const nav = useNavigate();
  const activeNav = ITEMS.find((it) => isUnder(loc.pathname, it.to));
  usePageMeta({
    title: `${activeNav ? activeNav.label + " \u2014 " : ""}Admin \u2014 SCW Contact Hub`,
    robots: "noindex, nofollow",
  });

  const signOut = async () => {
    try { await adminApi.logout(); } catch { /* ignore */ }
    nav("/admin/login");
  };

  const signOutBtn = (
    <button
      onClick={signOut}
      style={{ background: "transparent", color: "#FFFFFF", border: "1px solid rgba(255,255,255,0.5)", padding: "8px 16px", fontFamily: "inherit", fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", cursor: "pointer" }}
      data-testid="admin-signout-btn"
    >
      Sign out
    </button>
  );

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#FFFFFF" }}>
      <BrandHeader
        label={"Contact Hub \u00b7 Admin"}
        homeHref="/admin/dashboard"
        maxWidth={1280}
        rightSlot={signOutBtn}
        testIdPrefix="admin-header"
      />
      <div style={{ borderBottom: "1px solid var(--scw-line)", background: "#FFFFFF" }}>
        <nav style={{ maxWidth: 1280, margin: "0 auto", padding: "0 28px", display: "flex", gap: 0, overflowX: "auto" }}>
          {ITEMS.map((it) => {
            const active = isUnder(loc.pathname, it.to);
            return (
              <Link key={it.to} to={it.to}
                data-testid={`admin-nav-${it.to.split("/").pop()}`}
                style={{
                  padding: "16px 22px", fontSize: 12, letterSpacing: "0.18em",
                  textTransform: "uppercase", textDecoration: "none",
                  color: "#5C5C5C", borderBottom: active ? "2px solid #5C5C5C" : "2px solid transparent",
                  whiteSpace: "nowrap",
                }}>{it.label}</Link>
            );
          })}
        </nav>
      </div>
      <main style={{ flex: 1, width: "100%" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto", padding: "36px 28px 80px 28px" }}>
          {children}
        </div>
      </main>
      <footer className="scw-footer">
        <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 28px" }}>
          <a href="https://swisswatch.com.my/policies/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>
        </div>
      </footer>
    </div>
  );
}
